import { router } from 'expo-router';
import * as React from 'react';
import { useState } from 'react';
import {
    BodyLargeEmphasized,
    BodyMediumRegular,
    borderCurve,
    Button,
    ButtonSize,
    ButtonVariant,
    Image,
    SafeAreaView,
    ScreenContainer,
    XStack,
    YStack,
} from 'smoothie';

import FirstFundingTransferImage from '../../../../../assets/images/banking/first-funding-transfer.png';
import { useAuthedUser } from '../../../../common/providers/AuthedUserProvider';
import { useViewEvents } from '../../../../events/hooks/useViewEvents';
import { useUser } from '../../../../user/providers/UserProvider';
import { usePlaidEvents } from '../../../hooks/plaid/usePlaidEvents';
import { EBBankServicesDisclosure } from '../../Disclosures';
import Plaid from '../../plaid/Plaid';
import { NeedsReviewSheet } from '../../transfers/NeedsReview';

const FirstFunding = () => {
    const { trackViewOnce } = useViewEvents();
    trackViewOnce('FirstFunding');

    const { refetch: refetchUser } = useUser();
    const user = useAuthedUser();

    const [showEmptyScreen, setShowEmptyScreen] = useState(false);
    const [isReviewSheetOpen, setIsReviewSheetOpen] = useState(false);

    usePlaidEvents(setShowEmptyScreen);

    const onSuccessfulPlaidLink = (needsReview?: boolean) => {
        void refetchUser?.();
        if (needsReview === true) {
            setIsReviewSheetOpen(true);
        } else {
            router.navigate({
                pathname: '/banking/transfer',
                params: { context: 'firstFunding' },
            });
        }
    };

    if (showEmptyScreen) {
        return (
            <SafeAreaView
                style={{ flex: 1, height: '100%', backgroundColor: 'white' }}
            ></SafeAreaView>
        );
    }

    return (
        <ScreenContainer
            title="Connect securely to fund your account"
            hasBackButton
            onFallbackRoute="/home/banking"
            onBack={() => {
                router.back();
            }}
        >
            <YStack flex={1} gap={24} justifyContent="space-between">
                <YStack gap={24} alignItems="center">
                    <Image
                        source={FirstFundingTransferImage}
                        style={{
                            height: 250,
                            maxWidth: '100%',
                        }}
                        alignSelf="center"
                        resizeMode="contain"
                        aspectRatio="auto"
                    />
                    <BodyMediumRegular color="$gray1000" textAlign="center">
                        Link an external bank account through Plaid to transfer
                        funds in.
                    </BodyMediumRegular>
                </YStack>

                <YStack gap={12}>
                    <Plaid
                        user={user}
                        onSuccessfulLink={onSuccessfulPlaidLink}
                        onNeedsReview={() => {
                            setIsReviewSheetOpen(true);
                        }}
                    >
                        <XStack
                            // Use a dumbed down button component here.
                            // Plaid is super picky about what triggers the pop up and our fancy Button component doesn't play nicely with it.
                            alignItems="center"
                            justifyContent="center"
                            height={60}
                            backgroundColor="$black"
                            borderRadius={20}
                            {...borderCurve('continuous')}
                        >
                            <BodyLargeEmphasized color="$white">
                                Connect an account
                            </BodyLargeEmphasized>
                        </XStack>
                    </Plaid>
                    <Button
                        variant={ButtonVariant.TERTIARY}
                        size={ButtonSize.SMALL}
                        text="Skip for now"
                        onPress={() => {
                            router.navigate({
                                pathname: '/banking/create-edit-space',
                                params: { fromKyc: 'true' },
                            });
                        }}
                    />
                    <EBBankServicesDisclosure />
                </YStack>
            </YStack>
            <NeedsReviewSheet
                isOpen={isReviewSheetOpen}
                onClose={() => {
                    setIsReviewSheetOpen(false);
                    router.navigate({
                        pathname: '/banking/transfer',
                        params: { context: 'firstFunding' },
                    });
                }}
            />
        </ScreenContainer>
    );
};

export default FirstFunding;
